var _path, _rect, _rect2, _rect3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyChart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 138,
    viewBox: "0 0 130 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.253 5.18475C123.7 4.66162 124.491 4.59726 124.978 5.08414C125.465 5.57102 125.4 6.36186 124.877 6.80957L120.642 10.434C120.363 10.6732 119.944 10.6386 119.684 10.3784C119.424 10.1182 119.389 9.69931 119.628 9.41976L123.253 5.18475ZM128.345 15.185C129.032 15.1313 129.638 15.6452 129.638 16.3344C129.638 17.0236 129.032 17.5375 128.345 17.4837L122.786 17.0488C122.421 17.0202 122.151 16.7007 122.151 16.3344C122.151 15.968 122.421 15.6485 122.786 15.6199L128.345 15.185ZM112.578 1.71696C112.525 1.02984 113.038 0.424139 113.728 0.424139C114.417 0.424139 114.931 1.02984 114.877 1.71696L114.442 7.27585C114.414 7.6411 114.094 7.91131 113.728 7.91131C113.361 7.91131 113.042 7.64109 113.013 7.27585L112.578 1.71696Z",
    fill: "#B5B8C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 41,
    width: 20,
    height: 96,
    rx: 4,
    stroke: "#B5B8C3",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeDasharray: "6 8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 89,
    width: 20,
    height: 48,
    rx: 4,
    stroke: "#B5B8C3",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeDasharray: "6 8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 17,
    width: 20,
    height: 120,
    rx: 4,
    stroke: "#B5B8C3",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeDasharray: "6 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChart);
export default __webpack_public_path__ + "static/media/empty-chart.123f35c7c1150c0471350d7aae19c1e6.svg";
export { ForwardRef as ReactComponent };